import React from "react";
import { injectIntl } from "gatsby-plugin-intl";
import SEO from '../components/seo';

const Redirect = ({ intl }) => {
  return <SEO title="Touchlessr" />;
}

export default injectIntl(Redirect)
